{
  "WALLBOARD": {
    "LOADING": "S'estan carregant les cues de telèfon...",
    "NO_QUEUES": "No s'ha trobat cap cua de telèfon.",
    "NO_AGENTS": "No hi ha cap agent en línia en aquesta cua.",
    "UNKNOWN_CALLER": "Trucant desconegut",
    "STATUS": "Estat",
    "TIME": "Hora",
    "AGENT": "Agent",
    "EXTENSION": "Extensió",
    "READY": "Agents preparats",
    "ON_CALL": "Agents en trucada",
    "PAUSED": "Agents en pausa",
    "WAITING": "Trucades en espera",
    "MISSED_CALLS": "Trucades perdudes",
    "HANDLED_CALLS": "Trucades entrants ateses",
    "OUTBOUND_CALLS": "Trucades sortints ateses",
    "AVAILABILITY": "Disponibilitat",
    "AVAILABILITY_TOOLTIP": "Percentatge de trucades entrants ateses pels agents (trucades que s'han respost)",
    "AGENTS_COUNT": "({onCall} en trucada / {total} en total)",
    "NO_AVAILABLE": "(ningú en línia)",
    "WAITING_CALLERS_COUNT": "{count} en espera",
    "CALLER": "Trucant",
    "NUMBER": "Número",
    "WAIT_TIME": "Temps d'espera",
    "ACTION": "Acció",
    "PICKUP_CALL": "Agafa",
    "PICKUP_SUCCESS": "S'ha sol·licitat agafar la trucada correctament.",
    "PICKUP_ERROR": "No s'ha pogut agafar la trucada. Torna-ho a provar.",
    "PICKUP_DISABLED_TOOLTIP": "No pots agafar una trucada mentre estàs en una trucada o fora de línia.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Sense accés"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Sense accés"
    }
  }
}
